module.exports = __webpack_public_path__ + "src/img/undone.7e3bf5c8.svg";